import React from 'react';
import PropTypes from 'prop-types';
import ContactCard from './ContactCard';

const ContactsCardList = ({ contacts, contactFields, handleOpenViewModal }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {contacts.map((contact) => (
        <ContactCard
          key={contact.contactId || contact.id}
          contact={contact}
          contactFields={contactFields}
          handleOpenViewModal={handleOpenViewModal}
        />
      ))}
    </div>
  );
};

ContactsCardList.propTypes = {
  contacts: PropTypes.array.isRequired,
  contactFields: PropTypes.array.isRequired,
  handleOpenViewModal: PropTypes.func.isRequired,
};

export default ContactsCardList;
